import AnnualReports from '@scriptFe/features/AnnualReports.ts';
import BFGMasthead from '@scriptFe/features/BFGMasthead.ts';
import Button from '@scriptFe/features/Button.ts';
import DirectoryListing from '@scriptFe/features/DirectoryListing.ts';
import HeaderTogglePopup from '@scriptFe/features/HeaderTogglePopup.ts';
import MemberItem from '@scriptFe/features/MemberItem.ts';
import OfficialPartners from '@scriptFe/features/OfficialPartners.ts';
import Popup from '@scriptFe/features/Popup.ts';
import RaiseBecomeAMemberProcess from '@scriptFe/features/RaiseBecomeAMemberProcess.ts';
import SuccessStoriesSlider from '@scriptFe/features/SuccessStoriesSlider.ts';
import SuccessStory from '@scriptFe/features/SuccessStory.ts';
import Team from '@scriptFe/features/Team.ts';
import MastheadHome from "@scriptFe/features/animation/MastheadHome";
import CustomHsForm from './customHsForm.ts';
import Banner from '../features/Banner.ts';
import BFGProfile from '../features/BfgProfile.ts';
import BFGProfileMasthead from '../features/BfgProfileMasthead.ts';
import TextWithImage from '../features/TextWithImage.ts';
import BFGProfileImpactReport from '../features/BfgProfileImpactReport.ts';
import BfgProfileBrand from '../features/BfgProfileBrand.ts';
import ConvertPDF from "../features/ConvertPDF";
import ImageCarousel from '../features/ImageCarousel.ts';
import ImpactFrameWork from "../features/animation/ImpactFrameWork";
import CtaDouble from '../features/CtaDouble.ts';
import SubMasthead from "../features/animation/SubMasthead";
import Collapse from '../features/Collapse.ts';
import Tabs from '../features/Tabs.ts';
import CollapsePartnerLogo from "../features/CollapsePartnerLogo";
import EventsListing from '../features/EventsListing.ts';
import HandleWrapperOfficialPartner from "../features/HandleWrapperOfficialPartner";

interface DYNAMIC_CLASSES_PARAMS {
	className: string;
	item: HTMLElement;
	callback: string | string[];
	opt?: unknown;
}

const CLASSES = {
	SuccessStoriesSlider,
	HeaderTogglePopup,
	MemberItem,
	Team,
	AnnualReports,
	RaiseBecomeAMemberProcess,
	SuccessStory,
	OfficialPartners,
	Popup,
	Button,
	DirectoryListing,
	BFGMasthead,
	MastheadHome,
	CustomHsForm,
	Banner,
	BFGProfile,
	BFGProfileMasthead,
	TextWithImage,
	SubMasthead,
	BFGProfileImpactReport,
	BfgProfileBrand,
	ConvertPDF,
	ImageCarousel,
	CtaDouble,
	ImpactFrameWork,
	Collapse,
	Tabs,
	CollapsePartnerLogo,
	EventsListing,
	HandleWrapperOfficialPartner
};

class DynamicClass {
	constructor( { className, item, callback, opt = null }: DYNAMIC_CLASSES_PARAMS ) {
		return new CLASSES[ className ]( {
			item,
			callback,
			opt,
		} );
	}
}

export default DynamicClass;
